import { types } from 'actions/project_actions'
import conditions from './conditions'
import columns from './columns'

const handleId = (state = null, action) => {
  if (action.type === action.LOAD_REPORT) { return action.report.id }
  return state
}

const initialState = {
  id: null,
  columns: [],
  conditions: null
}

export default function (state = initialState, action) {
  return {
    id: handleId(state.id, action),
    columns: columns(state.columns, action),
    conditions: conditions(state.conditions, action),
  }
}
